import { fetchWithAuth } from './auth';
import { listQueueItems } from './syncQueue';

const ACTIVE_ORG_KEY = 'activeOrgId';

export interface OrgMembership {
  org_id: string;
  org_name: string;
  role: string;
  is_current: boolean;
}

export function getActiveOrgId(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(ACTIVE_ORG_KEY);
}

export function setActiveOrgId(orgId: string): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(ACTIVE_ORG_KEY, orgId);
}

export async function listMyOrgs(): Promise<OrgMembership[]> {
  const r = await fetchWithAuth('/api/my-orgs');
  if (!r.ok) throw new Error(`listMyOrgs failed: ${r.status}`);
  return (await r.json()) as OrgMembership[];
}

export async function getUnsafeSwitchState(): Promise<{
  hasUnsyncedItems: boolean;
  unsyncedCount: number;
  affectedJobCount: number;
}> {
  const items = await listQueueItems();
  const unsynced = items.filter((item) => item.status !== 'confirmed');
  return {
    hasUnsyncedItems: unsynced.length > 0,
    unsyncedCount: unsynced.length,
    affectedJobCount: new Set(unsynced.map((item) => item.job_id)).size,
  };
}

export function clearOrgScopedWorkingState(): void {
  try {
    sessionStorage.removeItem('eva-field:last-route');
  } catch {
    // storage unavailable
  }
}
